import { absolutePath } from "./absolutePath";

export const importContacts = {
  create: () => absolutePath("bulk_import_contacts"),
  createUsingOneSchema: () => absolutePath("one_schema_import_contacts"),
};
